import './founders.component.js';
import './about.component.js';
import './areas.component.js';